import React, { useEffect, useState, Suspense } from "react";
import Header from "./Header"
import About from "./About"
import Splash from "./Splash"
import Skills from "./skills";
import Services from "./Services";
//import Work from "./Work";
import Facts from "./Facts";
import More from "./More";
import News from "./News";
import Brand from "./Brand";
import Top from "./Top";
import Footer from "./Footer";
import Dev from "./Dev";
import AnimatedCursor from "react-animated-cursor";
import Modal from "react-modal";
import sound from "../assets/sound/sound.mp3";

const Work = React.lazy(() => import("./Work"));

Modal.setAppElement("#root");

function Home() {

    const [splash, setSplash] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [identifier, setIdentifier] = useState(false);

    useEffect(()=>{
        window.scrollTo({ top: 0, left: 0 });
        setTimeout(()=>{setSplash(false)},1500);
        const select = document.getElementById('point');
        if(window.screen.width>500)
        try {
            setTimeout(()=>{select.removeChild(select.firstChild)},100);
        } catch(e) {}
    },[]);

    const scroll = window.requestAnimationFrame || function(callback){ window.setTimeout(callback, 1000/60)};
    const elementsToShow = document.querySelectorAll('.show-on-scroll'); 

    const isElementInViewport = (el) => {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
        }

        top+=100;

        return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
        );
    }

    const loop = () => {
        elementsToShow.forEach(function (element) {
        if (isElementInViewport(element)) {
            element.classList.add('is-visible');
        } else {
            element.classList.remove('is-visible');
        }
        });
        scroll(loop);
    }
    
    loop();

    const modalOpener = () => {
        setIsOpen(true);
        try {
            //setTimeout(()=>{document.getElementsByClassName("copyright-text")[1].scrollIntoView();},100);
            setTimeout(()=>{
                document.getElementsByClassName("ReactModal__Content--after-open")[0].childNodes[0].scrollIntoView({block:"end"});
                document.getElementsByClassName("ReactModal__Content--after-open")[1].childNodes[0].scrollIntoView({block:"end"});
            },100);
        } catch (e) { 
            console.log(e); 
        }
        setTimeout(()=>setIsOpen(false),2000);
        document.getElementById('page1').classList.toggle('hidden');
        document.getElementById('page2').classList.toggle('hidden');
    }

    const pageTransition = () => {
        setIdentifier(false);
        modalOpener();
        window.scrollTo({ top: 0, left: 0 });
    }

    const pageBack = () => {
        setIdentifier(true);
        modalOpener();
        window.scrollTo({ top: document.body.scrollHeight, left: 0 });
    }

    const cont = {
        top: '0',
        left: '0',
        right: 'auto',
        bottom: 'auto',
        marginRight: '0',
        width: '100%',
        height: '100vh',
        background: '#191919',
        padding: '0',
        border: 'none',
        overflow: 'hidden',
    }

    const Mode = () => {
        if(identifier) {
            return (
                <div>        
                    <Modal isOpen={isOpen} style={{content: cont}}>
                        <div className="active-dark">
                            <Facts />
                            <Footer />
                        </div>
                    </Modal>
                    <Modal isOpen={isOpen} style={{content: {...cont, animation: 'scroller2 1s 1 .1s ease-out forwards'}}}>
                        <div className="active-dark">
                            <Dev />
                        </div>
                    </Modal>
                </div>
            );
        } else {
            return (
                <div>
                    <Modal isOpen={isOpen} style={{content: cont}}>
                        <div className="active-dark">
                            <Dev />
                        </div>
                    </Modal>
                    <Modal isOpen={isOpen} style={{content: {...cont, animation: 'scroller 1s 1 .1s ease-out forwards'}}}>
                        <div className="active-dark">
                            <Facts />
                            <Footer />
                        </div>
                    </Modal>
                </div>
            );
        }
    }

    return (
        <div className="active-dark">
            <audio id="audio" autoPlay>
                <source src={sound} type="audio/mp3" />
            </audio>
            <div id="point">
                <AnimatedCursor innerSize={12} color='238,7,57' innerScale={5} />
            </div>
            <Mode />
            <div id="page1">
                {splash && <Splash />}
                <Header />
                <About />
                <Skills />
                <Services />
                <News />
                <More />
                <Suspense fallback={<div>Loading...</div>}>
                    <Work />
                </Suspense>
                <Facts />
                <Top onPageTransition={pageTransition}/>
                <Footer />
            </div>
            <div id="page2" className="hidden">
                <Dev />
                <Top onPageBack={pageBack} value="2"/>
            </div>
        </div>
    );
}

export default Home;
